import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject, Observable, filter, takeUntil, switchMap, startWith, map, combineLatest } from 'rxjs';
import { CountdownTime, CountdownTimerService } from '../../../services/countdown-timer.service';
import { TypesenseService } from '../../../services/typesense.service';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { Store } from '@ngrx/store';
import { selectShowAdditionalOffers } from 'src/app/stores/global/global.selectors';

@Component({
    selector: 'app-banner-trading-announcement',
    templateUrl: './banner-trading-announcement.component.html',
    styleUrls: ['./banner-trading-announcement.component.scss'],
    standalone: false
})
export class BannerTradingAnnouncementComponent implements OnInit, OnDestroy {
   showBanner = false;
   countdown$!: Observable<CountdownTime>;
   private isBrowser: boolean;
   private destroy$ = new Subject<void>();

   private readonly hiddenRoutes = [
      /^\/authentication/,
      /^\/supported-countries$/,
      /^\/supported-brokerages$/,
      /^\/investing-coverage$/,
      /^\/halal-trading-waitlist/,
   ];

   constructor(
      @Inject(PLATFORM_ID) platformId: Object,
      private countdownService: CountdownTimerService,
      private typesenseService: TypesenseService,
      private router: Router,
      private store: Store
   ) {
      this.isBrowser = isPlatformBrowser(platformId);
   }

   ngOnInit(): void {
      const config$ = this.typesenseService.getConfigData().pipe(
         takeUntil(this.destroy$)
      );

      const routeAllowed$ = this.router.events.pipe(
         filter((event): event is NavigationEnd => event instanceof NavigationEnd),
         map((event: NavigationEnd) => event.urlAfterRedirects || event.url),
         startWith(this.router.url),
         map((url: string) => !this.hiddenRoutes.some(pattern => pattern.test(url))),
         takeUntil(this.destroy$)
      );

      const showAdditionalOffers$ = this.store.select(selectShowAdditionalOffers).pipe(takeUntil(this.destroy$));

      combineLatest([config$, routeAllowed$, SubscriptionService.subscriptionData, showAdditionalOffers$])
         .pipe(takeUntil(this.destroy$))
         .subscribe(([config, routeAllowed, subData, showAdditionalOffers]) => {
            const isFree = !subData.isSubscribed || subData.newRole === 'free';
            const isPromoOnly = subData.isSubscribed && !subData.hasAnyNonPromotionalSubscription;
            const isMonthly = subData.isSubscribed && subData.period === 'monthly';
            const subAllowed = isFree || isPromoOnly || isMonthly;

            const displayConfig = !!config?.prod?.sticky_banner?.display;
            this.showBanner = displayConfig && routeAllowed && subAllowed && showAdditionalOffers;
         });

      if (this.isBrowser) {
         this.countdown$ = config$.pipe(
            filter(config => !!config?.prod?.sticky_banner?.display),
            switchMap(config => {
               const rawDate = config.prod.sticky_banner.countdown_date;
               const end_date = rawDate ? rawDate.replace(' ', 'T') : '';
               return this.countdownService.createCountdown(new Date(end_date));
            })
         );
      }
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }

   
}
